import styled, { css } from 'styled-components';
import Color from '@styles/Color';
import Theme from '@styles/Theme';

export const ToolbarWrapper = styled.div`
  display: flex;
`;

export const Dividehr = styled.div`
  height: 16px;
  border: 0.4px solid var(--subTextColor);
  margin: 0 6px;
`;

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  padding: 10px 12px;
  height: 40px;
  min-height: 40px;
  justify-content: center;
`;

const toolbarBtnStyle = css`
  position: relative;
  width: 28px;
  height: 28px;
  transition: 0.3s;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.2s;
  pointer-events: auto;

  svg {
    path {
      fill: var(--subTextColor);
    }
  }

  &:hover {
    color: var(--textColor);

    svg {
      path {
        fill: var(--textColor);
      }
    }
    &[data-tooltip]:not([data-tooltip=''])::before {
      // tooltip
      font-size: 12px;
      padding: 7px 8px;
      border-radius: 6px;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 30px;
      background-color: ${Color.GRAY_9};
      color: ${Color.WHITE};
      width: max-content;
      content: attr(data-tooltip);
      z-index: 1;
    }
  }

  ::-webkit-scrollbar {
    display: none !important;
  }
`;
export const ToolbarButton = styled.button`
  ${toolbarBtnStyle}
`;
export const ToolbarSelect = styled.select`
  ${toolbarBtnStyle}
`;

export const QuillToolbarStyles = css`
  --bg: 'transparent';
  --border: 1px solid var(--lineColor);
  --stroke: var(--textColor);
  --text: var(--textColor);
  --text-hover: var(--primaryColor);

  /* html mode */
  *[quill__html] {
    display: none;
    width: 100%;
    margin: 0;
    background: ${Color.GRAY_9};
    color: ${Color.BLUE_GRAY_2};
    outline: none;
    padding: 12px, 15px;
    line-height: 1.4;
    font-family: Consolas, Menlo, Monaco, 'Courier New', monospace;
    position: absolute;
    top: 0;
    bottom: 0;
    border: none;
  }

  *[quill__html*='-active-'] {
    display: initial;
  }

  .ql-size-48 {
    font-size: 48px;
  }
  .ql-size-32 {
    font-size: 32px;
  }
  .ql-size-24 {
    font-size: 24px;
  }
  .ql-size-20 {
    font-size: 20px;
  }
  .ql-size-18 {
    font-size: 18px;
  }
  .ql-size-16 {
    font-size: 16px;
  }
  .ql-size-15 {
    font-size: 15px;
  }
  .ql-size-14 {
    font-size: 14px;
  }
  .ql-size-13 {
    font-size: 13px;
  }
  .ql-size-12 {
    font-size: 12px;
  }
  .ql-size-11 {
    font-size: 11px;
  }

  .ql-editor {
    white-space: pre-line;
    font-size: var(--textSize);
    padding: 0;

    strong {
      font-weight: 800;
    }
    ul {
      padding: 0;
    }
    ol {
      padding: 0;
    }

    // placeholder
    &.ql-blank::before {
      font-style: normal;
      color: var(--subTextColor);
      left: 0;
    }
  }

  .ql-snow .ql-picker-label {
    display: flex !important;
  }

  .quill {
    a {
      color: var(--primaryColor);
    }
    .ql-tooltip {
      z-index: 2; //링크, 동영상 등의 툴팁 맨 위로 올라오게
      width: 260px;
      border-radius: 4px;
      box-shadow: ${Theme.shadow.dropdown};
      border: none;
      display: flex;
      align-items: center;
      padding: 8px;
      background: var(--backgroundColor);
      .ql-preview {
        display: flex;
        align-items: center;
        width: 100%;
        font-size: 14px !important;
        max-width: none;
        height: 40px;
        background: var(--bg);
        border-radius: 4px;
        padding: 9px 16px;
        color: var(--text);
        font-size: 14px;
        transition: 0.2s;
        ::-webkit-scrollbar {
          display: none !important;
        }
        :hover {
          background: var(--bg);
        }
      }
      .ql-action {
        height: 40px;
        background: var(--buttonBackgroundColor);
        margin-left: 8px;
        border-radius: 4px;
        padding: 11px 12px;
        display: flex;
        align-items: center;
        transition: background 0.2s;
        ::after {
          content: '수정';
          font-size: 14px;
          color: var(--buttonTextColor);
          font-weight: 700;
          line-height: 130%;
          border: none;
          padding: 0;
          margin: 0;
        }
      }
      .ql-remove {
        height: 40px;
        border: var(--border);
        margin-left: 8px;
        border-radius: 4px;
        padding: 11px 12px;
        display: flex;
        align-items: center;
        transition: background 0.2s;

        ::before {
          content: '삭제';
          font-size: 14px;
          color: var(--textColor);

          font-weight: 700;
          line-height: 130%;
          border: none;
          padding: 0;
          margin: 0;
        }
      }
      ::before {
        display: none;
      }
      &.ql-hidden {
        display: none;
      }
      &.ql-editing {
        ::before {
          display: none;
        }
        .ql-preview {
          display: none;
        }
        // link 생성 input
        input {
          width: 100% !important;
          font-size: 14px !important;
          height: 40px !important ;
          padding: 0 8px;
          background: var(--cardBackgroundColor);
          border: var(--border);
          border-radius: 4px;
          ::placeholder {
          }
          :focus {
            outline: none;
            border: var(--border);
            padding: 2px 4px;
          }
        }
        // link 활성화 '저장'버튼
        .ql-action {
          width: 50px;
          height: 40px;
          background: var(--buttonBackgroundColor);
          margin-left: 8px;
          border-radius: 4px;
          padding: 11px 12px;
          display: flex;
          align-items: center;
          transition: background 0.2s;

          ::after {
            margin-left: 2px;
            content: '저장';
            font-size: 14px;
            color: var(--buttonTextColor);
            font-weight: 700;
            line-height: 130%;
          }
        }
        .ql-remove {
          display: none;
        }
      }
    }
  }
`;

export const ToolbarContainer = styled.div<{
  dir?: 'flex-start' | 'center' | 'flex-end';
}>`
  display: flex;
  flex-direction: row;
  justify-content: ${({ dir }) => dir || 'flex-start'};
  align-items: center;
  font-family: var(--defaultFontFamily) !important;
  border: 0 !important;
  padding: 8px 0 !important;

  /* font dropdown에서 사이즈 바꾸는거임 */
  .ql-picker-item[data-value='11'] {
    font-size: 11px;
  }
  .ql-picker-item[data-value='12'] {
    font-size: 12px;
  }
  .ql-picker-item[data-value='13'] {
    font-size: 13px;
  }
  .ql-picker-item[data-value='14'] {
    font-size: 14px;
  }
  .ql-picker-item[data-value='15'] {
    font-size: 15px;
  }
  .ql-picker-item[data-value='16'] {
    font-size: 16px;
  }
  .ql-picker-item[data-value='18'] {
    font-size: 18px;
  }
  .ql-picker-item[data-value='20'] {
    font-size: 20px;
  }
  .ql-picker-item[data-value='24'] {
    font-size: 24px;
  }
  .ql-picker-item[data-value='32'] {
    font-size: 32px;
  }
  .ql-picker-item[data-value='48'] {
    font-size: 48px;
  }

  // html
  .ql-toggleHTML {
    font-size: 13px;
    font-weight: 600;
    width: max-content !important;
    color: var(--subTextColor);
    &:hover {
      color: var(--textColor);
    }
  }

  button {
    color: var(--subTextColor) !important;
    ${toolbarBtnStyle}
    &:hover {
      color: var(--textColor) !important;
    }
  }

  .ql-snow.ql-color-picker {
    .ql-picker-label {
      display: flex !important;
      justify-content: center !important;
      align-items: center !important;
    }
  }

  .ql-picker-label {
    svg {
      path {
        fill: var(--subTextColor);
      }
    }

    &:hover {
      color: var(--textColor) !important;
    }
    &.ql-active {
      ::before {
        color: var(--textColor) !important;
      }
    }
  }
  .ql-picker-item {
    &.ql-selected {
      color: var(--textColor) !important;
    }
    &:hover {
      color: var(--textColor) !important;
    }
  }
  .ql-picker {
    &.ql-expanded {
      .ql-picker-label {
        border-color: transparent !important;
      }
    }
    &.ql-size {
      width: 56px !important;
      color: var(--subTextColor) !important;
    }
    &.ql-header {
      color: var(--subTextColor) !important;
    }

    &[data-tooltip]:not([data-tooltip=''])&:hover {
      ::before {
        // tooltip
        font-size: 12px;
        padding: 7px 8px;
        border-radius: 6px;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        top: 30px;
        background-color: ${Color.GRAY_9};
        color: ${Color.WHITE};
        width: max-content;
        content: attr(data-tooltip);
        z-index: 1;
      }
    }
  }
  .ql-fill {
    fill: var(--subTextColor) !important;
  }
  .ql-stroke {
    stroke: var(--subTextColor) !important;
  }

  .ql-picker-options {
    border-color: transparent !important;
    background: var(--backgroundColor) !important;
    backdrop-filter: blur(8px);
  }

  @media (max-width: 480px) {
    flex-wrap: wrap;
  }
`;
